(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rr-request-quote"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rr-request-quote')) {
  customElements.define('rr-request-quote', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const details = this.querySelector('details');
      const select = this.querySelector('[data-quote-variant]');
      const sku = this.querySelector('[data-quote-sku]');
      const syncSku = () => { sku.value = select.selectedOptions[0]?.dataset.sku || ''; };
      select.addEventListener('change', syncSku);
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        const purchase = document.getElementById(this.dataset.productForm);
        const id = purchase?.querySelector('[name="id"]')?.value;
        const option = Array.from(select.options).find(o => o.dataset.id === id);
        if (option) select.selectedIndex = option.index;
        const quantity = purchase?.elements.namedItem('quantity')?.value;
        if (quantity && Number(quantity) > 0) this.querySelector('[data-quote-quantity]').value = quantity;
        syncSku();
      });
      this.querySelector('form').addEventListener('submit', syncSku);
      if (this.querySelector('[role="status"], [role="alert"]')) details.open = true;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
